import { html } from 'lighterhtml';
import { useMemo } from 'haunted/lib/core';
import classnames from 'clsx';

import { component } from '../../utils';
import { useCurrentSlide, useSliderPagination } from '../slider/slider.context';

import './slider-pagination.css';

function SliderPagination() {
  const { currentSlide, totalSlides } = useCurrentSlide();
  const { moveToSlide } = useSliderPagination();

  const paginationItems = useMemo(() => {
    // Create empty array from number
    // https://stackoverflow.com/a/33352604/831465
    return Array.from(Array(totalSlides).keys());
  }, [totalSlides]);

  return html`<ul class="eo-slider-pagination__list">
    ${paginationItems.map(
      (_, index) =>
        html`<li>
          <button
            aria-label="Slide ${index}"
            onClick=${() => moveToSlide(index)}
            class=${classnames({
              active: index === currentSlide,
            })}
          >
            <span></span>
          </button>
        </li>`
    )}
  </ul>`;
}

export const SliderPaginationElement = component(SliderPagination, {
  useShadowDOM: false,
});
